/**
 * @generated SignedSource<<5d560586e3a4481198d5d93473b28a8a>>
 * @relayHash 913ebbe3b1f363506c326bf31ff23ee5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 913ebbe3b1f363506c326bf31ff23ee5

import { ConcreteRequest } from 'relay-runtime';
export type Ch_createCallCaseSummaryFeedbackInput = {
  appointmentId: string;
  feedbackText: string;
};
export type chCreateCallCaseSummaryFeedbackMutation$variables = {
  input: Ch_createCallCaseSummaryFeedbackInput;
};
export type chCreateCallCaseSummaryFeedbackMutation$data = {
  readonly ch_createCallCaseSummaryFeedback: {
    readonly callCaseSummaryFeedback: {
      readonly appointmentId: number;
      readonly createdAt: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chCreateCallCaseSummaryFeedbackMutation = {
  response: chCreateCallCaseSummaryFeedbackMutation$data;
  variables: chCreateCallCaseSummaryFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CallCaseSummaryFeedback",
  "kind": "LinkedField",
  "name": "callCaseSummaryFeedback",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chCreateCallCaseSummaryFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createCallCaseSummaryFeedbackPayload",
        "kind": "LinkedField",
        "name": "ch_createCallCaseSummaryFeedback",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chCreateCallCaseSummaryFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createCallCaseSummaryFeedbackPayload",
        "kind": "LinkedField",
        "name": "ch_createCallCaseSummaryFeedback",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "913ebbe3b1f363506c326bf31ff23ee5",
    "metadata": {},
    "name": "chCreateCallCaseSummaryFeedbackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0eb7fa20e91b928dbad16d7bcc541060";

export default node;
